import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HookSection() {
  return <section className="w-full bg-white py-20 px-6" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <FadeIn data-id="element-58">
          <div className="prose prose-lg md:prose-xl text-charcoal" data-id="element-59">
            <p className="text-2xl md:text-3xl font-serif text-sage leading-relaxed mb-8 italic" data-id="element-60">
              "Estás en medio de una frase y, de repente, la palabra desaparece.
              Te quedas en blanco frente a tu jefe, tus hijos o tus amigos."
            </p>

            <p className="mb-6" data-id="element-61">
              Sientes ese calor en el cuello y el miedo silencioso:{' '}
              <em className="text-sage font-medium" data-id="element-62">
                ¿Me estoy volviendo vieja? ¿Es el principio de algo peor?
              </em>
            </p>

            <p className="mb-12 font-medium" data-id="element-63">
              La ciencia es clara: No estás perdiendo la cabeza. Tu cerebro
              simplemente tiene "hambre".
            </p>

            <div className="bg-cream-dark p-8 rounded-2xl border-l-4 border-sage mb-12" data-id="element-64">
              <p className="mb-0" data-id="element-65">
                Al entrar en los 45+, la caída de estrógenos corta el suministro
                de energía a tus neuronas. Tu cerebro está funcionando con una
                batería vieja, pero existe un interruptor biológico para
                encenderlo de nuevo.
              </p>
            </div>

            <h3 className="text-3xl font-bold mb-6" data-id="element-66">
              La "niebla mental" no es solo cansancio.
            </h3>

            <ul className="space-y-4 mb-8 list-none pl-0" data-id="element-67">
              <li className="flex items-start gap-3" data-id="element-68">
                <span className="text-gold mt-1" data-id="element-69">✦</span>
                <span data-id="element-70">Es entrar a una habitación y olvidar a qué ibas.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-71">
                <span className="text-gold mt-1" data-id="element-72">✦</span>
                <span data-id="element-73">
                  Es tener que leer tres veces la misma página para entenderla.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-74">
                <span className="text-gold mt-1" data-id="element-75">✦</span>
                <span data-id="element-76">
                  Es sentir que tu agudeza profesional se desvanece mientras el
                  mundo sigue girando rápido a tu alrededor.
                </span>
              </li>
            </ul>

            <p className="mb-6" data-id="element-77">
              Intentas dormir más, tomas más café o compras vitaminas genéricas,
              pero nada cambia.
            </p>
            <p className="font-medium text-sage" data-id="element-78">
              El café solo acelera un motor vacío, y el azúcar te da un pico de
              energía que termina en un "crash" mental una hora después,
              dejándote más confundida y agotada que antes.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}